import axios from 'axios';
import apiConfig from '../../api.config';

export default function getPaperlessUserHotels(email) {
  const {
    host,
    URIs: { getPaperlessUserHotels },
  } = apiConfig;

  const uri = `${host}${getPaperlessUserHotels}`.replace(':email', email);

  return axios
    .get(uri, {
    })
    .then(res => {
      return res.data;
    });
}
